import React, { useEffect, useState } from 'react'
import { useStateValue } from '../../StateProvider'
import { getDefaultName, getDefaultValue } from '../../utils'
import { resolveMediaUrl } from '../../utils/Network'
import { ContestHttpService } from '../../utils/http/contest_http_service'
import { loadProfile } from '../../utils/Network'
import Constants from '../../utils/Constants'
import ModalContestView from '../dialogs/ModalContestView'
import ParticipateButtonSingle from './ParticipateButtonSingle'
import parse from 'html-react-parser'

function ContestParticipation({ talentId, contestViewHideImage = false, hideUnrollWhenEnrolled = false, ...props }) {

    const [contest, setContest] = useState(null)
    const [contestIsNotAvailable, setContestIsNotAvailable] = useState(false)
    const [contestViewModalIsOpen, setContestViewModalIsOpen] = useState(false)
    const [profile, setProfile] = useState(null)

    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x => x.key == str);

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };

    useEffect(() => {
        _getData()
    }, [])

    useEffect(() => {
        loadProfile()
            .then((p) => setProfile(p))
            .catch(() => setProfile(null))
    }, [])

    const _getData = () => {
        var query = "?talent=" + encodeURIComponent(talentId)
        ContestHttpService.loadContests(query).then((data) => {
            if (data.results) {
                if (data.count > 0) {
                    setContest(data.results[0])
                }
                else {
                    setContest(null)
                    setContestIsNotAvailable(true)
                }
            }
            else {
                setContest(null)
                setContestIsNotAvailable(true)
            }
        });
    }


    return (
        <div>
            {contest && (
                <div className="contest-participation">
                    <div className="contest-participation__inner">
                        <div className="contest-participation__media">
                            <button
                                type="button"
                                className="contest-participation__details"
                                onClick={() => { setContestViewModalIsOpen(true) }}
                                title={translate("View contest details")}
                                aria-label={translate("View contest details")}
                            >
                                <i className="fa fa-exclamation" aria-hidden="true" />
                            </button>
                            <img
                                src={contest.image ? resolveMediaUrl(contest.image) : contest.image}
                                className="contest-participation__img"
                                alt={getDefaultName(contest.names) || ''}
                            />
                        </div>
                        <div className="contest-participation__body">
                            <span className="contest-participation__eyebrow kfont">
                                {translate("Ready to participate?")}
                            </span>
                            <h3 className="contest-participation__title kfont">
                                {getDefaultName(contest.names)}
                            </h3>
                            {profile != null && !profile.country_id && (
                                <p className="contest-participation__profile-hint mb-3" role="status">
                                    {translate(Constants.ContestCompleteYourProfileMessage)}
                                </p>
                            )}
                            <div className="contest-participation__actions">
                                <ParticipateButtonSingle
                                    course={contest.id}
                                    courseTitle={getDefaultName(contest.names)}
                                    hideUnrollWhenEnrolled={hideUnrollWhenEnrolled}
                                    onParticipationChange={props.onParticipationChange}
                                    onSuccess={(courseParticipant) => {
                                        if (props.onSuccess) {
                                            props.onSuccess(courseParticipant)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {contestIsNotAvailable && (<>
                <div className="mx-3 contest-not-availabe">
                    {parse(translate('There is no contest available now.'))}
                </div>
            </>)}

            <ModalContestView
                isOpen={contestViewModalIsOpen}
                setIsOpen={setContestViewModalIsOpen}
                contest={contest}
                hideImage={contestViewHideImage}
            />

        </div>
    )
}

export default ContestParticipation
